/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDButton from "components/MDButton";

// Billing page components
import MUIDataTable from "mui-datatables";

// ##############ICONS IMPORTS################
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import Divider from "@mui/material/Divider";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import { StyledEngineProvider } from "@mui/material/styles";
import React, { useEffect, useState } from "react";

import OficinaService from "services/Oficina";
import MateriaService from "services/Materias";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  IconButton,
  Card,
} from "@mui/material";
import { Box } from "@mui/system";

import "./filters.css";
import { SignalWifiStatusbarNull } from "@mui/icons-material";

interface LocalFilters {
  nombre: string;
  apellido: string;
  habilitado: boolean;
}
function Filters({ filtersState, setFiltersState, applyFiltersHandler }) {
  // const [localFilters, setLocalFilters] = useState<LocalFilters>(filtersState);
  const [ materias, setMaterias] = useState([]);
  const [oficinas, setOficinas] = useState([]);
 
  useEffect(() => {
   
    MateriaService.getMateria({}).then((response) => {
      setMaterias(response.data);
    }
    );
    OficinaService.getOficina({}).then((response) => {
      setOficinas(response.data);
    }
    );
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <div>
        <div className="containerTitle">
          <MDTypography variant="h6" fontWeight="medium">
            Búsqueda de Oficinas {filtersState.nombre}
          </MDTypography>
        </div>
        <Divider variant="middle" className="thickDivider" />
        <div className="container">
          <div className="input1">
          <Autocomplete
              id="combo-box-demo"
              options={oficinas}
              value={filtersState.oficina}
              sx={{ width: 300, marginBottom: "15px" }}
              getOptionLabel={(option) => option.descripcion_oficina}
              renderInput={(params) => <TextField {...params} label="Oficina" />}
              onChange={(event, newValue) => {
                setFiltersState((prev) => ({ ...prev, oficina: newValue }));
              }}
            />
          </div>
          <div className="input2">
            <Autocomplete
              id="combo-box-demo"
              options={materias}
              value={filtersState.materia}
              sx={{ width: 300, marginBottom: "15px" }}
              getOptionLabel={(option) => option.descripcion_materia}
              renderInput={(params) => <TextField {...params} label="Materia" />}
              onChange={(event, newValue) => {
                setFiltersState((prev) => ({ ...prev, materia: newValue }));
              }}
            />
          </div>
          <div className="input3">
            {" "}
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filtersState.habilitado}
                    onChange={(value) => {
                      setFiltersState((prev) => ({
                        ...prev,
                        habilitado: value.target.checked,
                      }));
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Habilitado"
              />
            </FormGroup>
          </div>
          {/* <div className="input3">
            {" "}
            <TextField id="standard-basic" label="Fecha de Creacion" variant="standard" />
          </div> */}
        </div>
        <Divider variant="middle" className="thickDivider" />
        <Button
          color="warning"
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={applyFiltersHandler}
        >
          Aplicar
        </Button>
        <Button
          color="warning"
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => {
            setFiltersState({ oficina: null, habilitado: true, materia: null }); // will catch in useEffect if values are default, do a backend call
          }}
        >
          Limpiar
        </Button>
      </div>
    </StyledEngineProvider>
  );
}

export default Filters;
